module.exports = "<div gw-loader></div>"